
import { defineComponent } from "vue";

export default defineComponent({
  name: "Home",
  data() {
    return {
      roomName: "",
    };
  },
  methods: {
    joinRoom() {
      this.$router.push({ name: "Room", params: { name: this.roomName } });
    },
  },
});
